module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-telefon-7afb5ddac57931f689cbb8acacb866a9.svg";